// extracted by mini-css-extract-plugin
module.exports = {"gallery":"styles_gallery__3IixO","row-element":"styles_row-element__34nJW","rowElement":"styles_row-element__34nJW","description":"styles_description__1Bepf"};